<template>
  <div class="payment1">
    <c-inputLine
      name="userName"
      maxLength="50"
      :promptText="promptText1"
      :errorHave="true"
      :errorText="errorText1"
      :errorFlag="checkErrorFlag1"
      marginTop="0px"
      :disabled="excheifFlag ? false : isCanModifyName"
      :value="checkValue1"
      @onchanges="inputChanges"
      newStyleFormat
    >
    </c-inputLine>
    <c-inputLine
      name="account"
      maxLength="50"
      :promptText="promptText2"
      :errorHave="true"
      :errorText="errorText2"
      :errorFlag="checkErrorFlag2"
      marginTop="0px"
      :value="checkValue2"
      @onchanges="inputChanges"
      newStyleFormat
    >
    </c-inputLine>
    <div class="upload_div a-4-bg a-2-bd">
      <div v-if="imgLoading">
        <c-loading size="34" className="common-button-loading a-12-bd" />
        <p class="b-4-cl loading-text">{{ $t("personal.prompt.uploading") }}</p>
      </div>
      <div v-else>
        <div class="loading-mc" v-if="imgSrc !== ''">
          <img :src="imgSrc" class="loading-img" />
          <div class="b-2-bg"></div>
        </div>
        <div class="loading-text2">
          <svg class="icon icon-24" aria-hidden="true">
            <use xlink:href="#icon-e_10"></use>
          </svg>
          <p class="b-4-cl">
            {{
              imgSrc ? $t("personal.prompt.uploadQrCodAgain") : $t("personal.prompt.uploadQrCod")
            }}
          </p>
        </div>
      </div>
      <c-oldUploadFile
        className="upload_file"
        maxSize="8"
        name="qrCode"
        url="common/upload_qrcode"
        :isOpenUploadImg="isOpenUploadImg"
        imageType="2"
        :expand="[]"
        :isWaterMark="true"
        @tellMessage="onChangeFileFun"
        @uploadFinish="uploadFinish"
      >
      </c-oldUploadFile>
    </div>
    <p class="upload_p">{{ $t("personal.prompt.uploadType") }}</p>
  </div>
</template>

<script>
export default {
  name: 'aliwe',
  data() {
    return {
      promptText1: '',
      errorText1: '',
      checkErrorFlag1: false,
      imageType: '2',
      checkValue1: '',
      promptText2: '',
      errorText2: '',
      checkErrorFlag2: false,
      checkValue2: '',
      isOpenUploadImg: '0',
      imgLoading: false,
      imgSrc: '',
      imgFile: '',
    };
  },
  props: {
    payments: {
      default: () => {},
      type: Object,
    },
    isModify: {
      type: Number,
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      if (this.payments !== null) {
        this.promptText1 = this.payments.name;
        this.promptText2 = this.payments.title;
        if (this.payments.obj) {
          this.checkValue1 = this.payments.obj.userName;
          this.checkValue2 = this.payments.obj.account;
          this.imgSrc = this.payments.obj.qrcodeImg;
        }
      }
      const { publicInfo } = this.$store.state.baseData;

      if (publicInfo !== null) {
        this.isOpenUploadImg = publicInfo.switch.is_open_upload_img;
      }

      if (this.isModify === 0 || this.isCanModifyName) {
        if (this.userInfo) {
          this.checkValue1 = this.userInfo.realName;
          const obj = {};
          obj.userName = this.userInfo.realName;
          this.$emit('callBack', 'payment1', 'userName', obj);
        }
      }
    },
    inputChanges(value, name) {
      if (name === 'userName') {
        this.checkValue1 = value;
      } else {
        this.checkValue2 = value;
      }
      const obj = {};
      obj[name] = value;
      this.$emit('callBack', 'payment1', name, obj);
    },
    uploadFinish(obj) {
      if (obj.error) {
        this.$bus.$emit('tip', { text: obj.error, type: 'error' });
        return;
      }
      this.imgLoading = false;
      this.imgSrc = obj.url;
      this.imgFile = obj.fileName;
      const img = !Number(this.clientUploadType) ? this.imgSrc : this.imgFile;
      this.$emit('callBack', 'payment1', 'qrcodeImg', { qrcodeImg: img });
    },
    onChangeFileFun() {
      this.imgLoading = true;
    },
  },
  computed: {
    userInfo() {
      return this.$store.state.baseData.userInfo;
    },
    isCanModifyName() {
      return this.userInfo && Number(this.userInfo.userCompanyInfo.status) === 0;
    },
    excheifFlag() {
      return this.$store.state.baseData.exchief_project_switch;
    },
  },
  watch: {
    userInfo(v) {
      if (this.isModify === 0 || this.isCanModifyName) {
        if (v) {
          this.checkValue1 = v.realName;
          const obj = {};
          obj.userName = v.realName;
          this.$emit('callBack', 'payment1', 'userName', obj);
        }
      }
    },
    payments(payments) {
      if (payments !== null) {
        this.promptText1 = payments.name;
        this.promptText2 = payments.title;
        if (payments.obj) {
          this.checkValue2 = payments.obj.account;
          this.imgSrc = payments.obj.qrcodeImg;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.payment1 {
  width: 100%;
  .upload_div {
    width: 120px;
    height: 120px;
    border-style: dashed;
    border-width: 1px;
    box-sizing: border-box;
    position: relative;
    overflow: hidden;
    svg {
      margin: 36px 47px 12px 47px;
    }
    p {
      font-size: 12px;
      text-align: center;
    }
    .upload_file {
      width: 120px;
      height: 120px;
      position: absolute;
      cursor: pointer;
      top: 0;
      left: 0;
      z-index: 2;
    }
    .common-button-loading {
      position: absolute;
      vertical-align: middle;
      left: 50%;
      margin-left: -17px;
      top: 45px;
      transform: translateY(-50%);
    }
    .loading-mc {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      div {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0.7;
      }
      .loading-img {
        width: 100%;
        height: 100%;
        margin: 0;
      }
    }
    .loading-text2 {
      z-index: 3;
      position: relative;
    }
    .loading-text {
      margin-top: 70px;
    }
  }
  .upload_p {
    font-size: 12px;
    margin: 12px 0 24px 0;
  }
}
</style>
